// Pollyfills for IE11
import "intersection-observer";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import App from "App";
import "fonts.css";
import "i18n/i18n";
import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

ReactDOM.render(
  <Suspense fallback={null}>
    <BrowserRouter basename={process.env.REACT_APP_BASE_RELATIVE_ROUTES}>
      <App />
    </BrowserRouter>
  </Suspense>,
  document.getElementById("root")
);
